// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';

import router from '@app/router'; // default export is the router OBJECT
import AppThemeProvider from './app/providers/ThemeProvider';
import { NotificationProvider } from './app/notifications/NotificationProvider';
// Supports weights 100-900
import "@fontsource/inter/latin.css";


import 'leaflet/dist/leaflet.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppThemeProvider>
      {/* Single global notification host. Every page uses useNotifications()
          from '@app/notifications/NotificationProvider' — no more mixing
          with the old SnackbarProvider or inline <Snackbar> patterns. The
          NotificationProvider also registers with notifyBridge so non-React
          callers (axios interceptor, boot-time errors) can fire toasts. */}
      <NotificationProvider>
        <RouterProvider router={router} />
      </NotificationProvider>
    </AppThemeProvider>
  </React.StrictMode>
);

